// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getComunalGardenlistStatus: { data: null },
  createCommunalGardenStatus: { data: null },
  editCommunalGardenStatus: { data: null },
  deleteCommunalGardenStatus: { data: null },
};
